export default "__VITE_ASSET__DLloUh1r__"